<template>
  <div>
    <facit-header></facit-header>
      <div class = "profile-div col-12">
        <h5 class="mt-3 mb-3"> Identity Cloak </h5>
        <br><br>
        <div class="wdiv">
          <b-embed
            type="iframe"
            aspect="16by9"
            src="https://www.youtube.com/embed/qc2viroDG5w"
          ></b-embed>
        </div>
        <h5 class="mt-3 mb-3"> Applications </h5>
        <b-table  striped hover
                  :fields="fields"
                  :items="applications">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table><br><br><br>
        <h5 class="mt-3 mb-3"> Technical Documentation </h5>
        <b-table  striped hover
                  :fields="fields"
                  :items="documents">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table><br><br><br>
        <h5 class="mt-3 mb-3"> Marketing </h5>
        <b-table  striped hover
                  :fields="fields"
                  :items="videos">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table><br><br><br>
        <h5 class="mt-3 mb-3"> Recommended Hardware </h5>
        <b-table  striped hover
                  thead-class="hidden_header"
                  :items="hardware">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table>
      </div>
  </div>
</template>

<script>
import FacitHeader from '@/components/header';
import API from '@/api';

export default {
  name: 'IdentityCloak',
  components: { FacitHeader },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      applications: [],
      documents: [],
      videos: [],
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'version',
          label: 'Version',
          sortable: true,
        },
        {
          key: 'size',
          label: 'Size',
          sortable: true,
        },
        {
          key: 'link',
          label: 'Downloads',
          sortable: false,
        },
      ],
      hardware: [
          { age: 'Operating System', first_name: 'Windows Pro 7/10' },
          { age: 'Processor', first_name: 'Intel Core i7' },
          { age: 'RAM', first_name: '8 GB'},
          { age: 'Free Disk Space', first_name: '50 GB'},
          { age: 'Browser', first_name: 'Chrome'},
          { age: 'Input File Format', first_name: '.avi .mp4 .mkv .vob'},
          { age: 'Codecs', first_name: 'MJPEG,MPEG-4,H.264,x264,FLV'},
        ],
    };
  },
  created() {
    this.getDownloads();
  },
  methods: {
    async getDownloads() {
      const downloads = await API.get('Downloads');

      downloads.forEach(records => {
        if (records.type === 3) {
          this.applications.push(records)
        } else if (records.type === 4) {
          this.documents.push(records)
        } else if (records.type === 5) {
          this.videos.push(records)
        }
      })
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}
.wdiv {
  width: 500px;
  margin: auto;
}
.hidden_header {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/identityCloak.vue